(() => {
  const SELECTOR = '.card-hover-zoom-in, .card-hover-zoom-out';

  // Only on touch devices; desktop uses hover
  if (!window.matchMedia('(hover: none)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('card-in-view');
      observer.unobserve(entry.target);          // play once
    });
  }, { threshold: 0.4 });

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((card) => {
      if (!card.classList.contains('card-in-view')) observer.observe(card);
    });
  };

  init();

  // Re-run when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();